<template>
  <div class="center-content login-background">
    <div class="title-frame">
      <h1 class="title">Acroファイル交換サービス</h1>
    </div>
    <div class="login-card">
      <div class="ui segment frame">
        <i class="massive user circle icon"></i>
        <h2>ログイン</h2>

        <!-- エラーメッセージ -->
        <div class="ui error message frame" v-show="errorMessageList.length !== 0">
          <ul class="list">
            <li v-for="(message, index) in errorMessageList" :key="index">{{message}}</li>
          </ul>
        </div>

        <!-- 入力フォーム -->
        <form id="exchangeLogin-form" class="ui large form frame" @submit.prevent="login">
          <a
            id="exchangeLogin-form__federated-login"
            :href="getFederatedLoginUrl"
            class="ui fluid huge button blue"
          >acroquest.co.jpでログイン</a>

          <div class="login-margin" v-if="!showDirectLogin">
            <a
              id="exchangeLogin-form__direct-login-switch"
              class="link"
              href="javascript:void(0)"
              @click="showDirectLogin = true"
            >ダイレクトログイン</a>
          </div>

          <div id="exchangeLogin-form__direct-login" v-if="showDirectLogin">
            <div class="ui horizontal divider">OR</div>

            <div class="field" :class="{ 'error': $v.email.$error }">
              <div class="ui left icon input">
                <i class="mail icon"></i>
                <input
                  id="exchangeLogin-form__direct-login__email"
                  v-model.trim="email"
                  @blur="$v.email.$touch()"
                  @focus="$v.email.$reset()"
                  type="email"
                  name="email"
                  placeholder="メールアドレス"
                />
              </div>
            </div>
            <div class="error" v-if="$v.email.$error && !$v.email.required">メールアドレスを入力してください</div>
            <div
              class="error"
              v-if="$v.email.$error && $v.email.required && !$v.email.email"
            >E-mail形式で入力してください</div>

            <div class="field" :class="{ 'error': $v.password.$error }">
              <div class="ui left icon input">
                <i class="lock icon"></i>
                <input
                  id="exchangeLogin-form__direct-login__password"
                  v-model.trim="password"
                  @blur="$v.password.$touch()"
                  @focus="$v.password.$reset()"
                  type="password"
                  name="password"
                  placeholder="パスワード"
                />
              </div>
            </div>
            <div class="error" v-if="$v.password.$error && !$v.password.required">パスワードを入力してください</div>
            <button
              id="exchangeLogin-form__direct-login__submit"
              type="submit"
              class="ui fluid large button blue"
              :class="{'disabled': $v.$invalid}"
            >ログイン</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { signIn, federatedSignIn } from '@/auth'
import { required, email } from 'vuelidate/lib/validators'
import { OPENID_CONNECT } from '@/environment'

export default {
  title: 'ログイン',
  data: function () {
    return {
      email: '',
      password: '',
      errorMessageList: [],
      showDirectLogin: false
    }
  },
  validations: {
    password: {
      required
    },
    email: {
      required,
      email
    }
  },
  created: function () {
    this.$store.commit('progress/setLoading', true)
    if (this.$route.query.code) {
      federatedSignIn(this.$route.fullPath)
        .then(() => this.$router.push({ path: '/exchange/list' }))
        .catch(() => {
          this.$store.commit('progress/setLoading', false)
          this.$router.push({ path: '/exchange/login' })
        })
    } else {
      this.$store.commit('progress/setLoading', false)
    }
  },
  methods: {
    login: function () {
      this.$store.commit('progress/setLoading', true)
      this.errorMessageList = []
      signIn(this.email, this.password)
        .then(data => {
          this.$router.push({ name: 'exchangeList' })
        })
        .catch(e => {
          this.errorMessageList.push('認証に失敗しました。')
          this.$store.commit('progress/setLoading', false)
        })
    }
  },
  computed: {
    getFederatedLoginUrl: function () {
      const domain = OPENID_CONNECT.AppWebDomain
      const clientId = OPENID_CONNECT.ClientId
      const redirectUri = OPENID_CONNECT.RedirectUriSignIn
      return `https://${domain}/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`
    }
  }
}
</script>
<style>
.login-background {
  height: 100%;
  background: linear-gradient(
    0deg,
    #ffffff 0%,
    #ffffff 50%,
    var(--main-color) 50%,
    var(--dark-color) 100%
  );
}

.title {
  font-size: 60px;
  color: #ffffff;
}

.title-frame {
  padding: 5vh;
}

.login-card {
  width: 600px;
  margin: auto;
}

.ui.segment.frame {
  padding: 40px;
}

.massive.user.circle.icon {
  font-size: 10em;
}

.ui.form.frame {
  margin: 30px 40px 30px;
}

.ui.error.message.frame {
  margin: 0 40px;
}

a.link {
  text-decoration: underline;
}

.login-margin {
  padding-top: 40px;
}
</style>
